/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2021-10-19 12:30:39
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import { DEFAULT_FILTER_LAYOUT_SETTINGS } from 'src/constants/filter-layout';

/**
 * Build initial data for filter layout
 *
 * @param  {Object} filterSettings filter settings from API
 *
 * @return {Object} initialValue
 */
export const buildInitialFilterLayoutValues = (
  filterSettings: Object,
  shopifyIntegrationEnabled: boolean,
  i18n: Object
) => {
  let filterLayout = _.get(
    filterSettings,
    'general.filterLayout',
    DEFAULT_FILTER_LAYOUT_SETTINGS.filterLayout
  );
  const filterTreeVerticalStyle = _.get(
    filterSettings,
    'general.filterTreeVerticalStyle',
    DEFAULT_FILTER_LAYOUT_SETTINGS.filterTreeVerticalStyle
  );
  const filterTreeHorizontalStyle = _.get(
    filterSettings,
    'general.filterTreeHorizontalStyle',
    DEFAULT_FILTER_LAYOUT_SETTINGS.filterTreeHorizontalStyle
  );
  if (shopifyIntegrationEnabled) {
    // Enabled SSR
    filterLayout =
      filterLayout === 'vertical'
        ? `vertical_` + filterTreeVerticalStyle
        : `horizontal_` + filterTreeHorizontalStyle;
  }

  return {
    filterLayout,
    filterTreeVerticalStyle,
    filterTreeHorizontalStyle,
    filterTreeMobileStyle: _.get(
      filterSettings,
      'general.filterTreeMobileStyle',
      DEFAULT_FILTER_LAYOUT_SETTINGS.filterTreeMobileStyle
    ),
    stickyFilterOnDesktop: _.get(
      filterSettings,
      'general.stickyFilterOnDesktop',
      DEFAULT_FILTER_LAYOUT_SETTINGS.stickyFilterOnDesktop
    ),
    stickyFilterOnMobile: _.get(
      filterSettings,
      'general.stickyFilterOnMobile',
      DEFAULT_FILTER_LAYOUT_SETTINGS.stickyFilterOnMobile
    )
  };
};

/**
 * Build data for saving filter layout
 *
 * @param  {Object} data filter settings data
 * @param  {Object} filterSettings filter settings from API
 *
 * @return {Object} value value for sending API
 */
export const buildFilterLayoutValues = (
  data: Object,
  filterSettings: Object,
  shopifyIntegrationEnabled: boolean
) => {
  let { filterLayout, filterTreeVerticalStyle, filterTreeHorizontalStyle } = data;
  if (shopifyIntegrationEnabled) {
    // Enabled SSR
    const splittedData = _.split(filterLayout, '_');
    filterLayout = splittedData[0];
    if (filterLayout === 'vertical') {
      filterTreeVerticalStyle = splittedData[1];
    } else {
      filterTreeHorizontalStyle = splittedData[1];
    }
  }
  return {
    ...filterSettings,
    general: {
      ...filterSettings.general,
      filterLayout,
      filterTreeVerticalStyle,
      filterTreeHorizontalStyle,
      filterTreeMobileStyle: data.filterTreeMobileStyle,
      stickyFilterOnDesktop: data.stickyFilterOnDesktop,
      stickyFilterOnMobile: data.stickyFilterOnMobile
    }
  };
};
